import { useEffect } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import {
  disablePartnerVendorDirectoryApi,
  enablePartnerVendorDirectoryApi,
} from "../../api/clientPortalFetch";
import { casamapaPartnerPortalPath } from "../../constants/casamapaPartnerPortalConfig";
import { casamapaPartnerVendorHubPath } from "../../constants/casamapaPartnerVendorPaths";
import { VendorDirectoryPartnerScopeProvider } from "../../hooks/useVendorDirectoryPaths";
import { useLocale } from "../../intl";
import PartnerVendorWorkspaceChrome from "./PartnerVendorWorkspaceChrome";
import "../../styles/partnerVendorWorkspace.css";
import "../../styles/casamapaVendorDirectoryAdmin.css";

function workspaceRelativePath(pathname, workspaceRoot) {
  const prefix = `${workspaceRoot}/`;
  if (!pathname.startsWith(prefix)) {
    return "";
  }
  return pathname.slice(prefix.length).replace(/^\/+|\/+$/g, "");
}

export default function PartnerVendorWorkspaceLayout() {
  const { clientViewId } = useParams();
  const location = useLocation();
  const { t } = useLocale();

  useEffect(() => {
    if (clientViewId) {
      enablePartnerVendorDirectoryApi(clientViewId);
    }
    return () => disablePartnerVendorDirectoryApi();
  }, [clientViewId]);

  if (!clientViewId) {
    return null;
  }

  const workspaceRoot = casamapaPartnerVendorHubPath(clientViewId);
  const relativePath = workspaceRelativePath(location.pathname, workspaceRoot);

  return (
    <VendorDirectoryPartnerScopeProvider clientViewId={clientViewId}>
      <div className="partner-vendor-workspace">
        <PartnerVendorWorkspaceChrome
          clientViewId={clientViewId}
          relativePath={relativePath}
          hubPathBuilder={casamapaPartnerVendorHubPath}
          dashboardPath={casamapaPartnerPortalPath("vendors")}
          dashboardLabel={t("realEstate.casaMapa.admin.vendorDirectoryWorkspace.vendors.title")}
          exitPath={casamapaPartnerPortalPath("vendors")}
          exitLabel={t("realEstate.casaMapa.admin.agencyPortal.exitAdmin")}
        />

        <div className="partner-vendor-workspace__content">
          <Outlet context={{ activeView: { name: "CasaMapa" }, partnerVendorDirectory: true }} />
        </div>
      </div>
    </VendorDirectoryPartnerScopeProvider>
  );
}
